'use client';

import {
    useParams,
    usePathname,
    useSearchParams,
    useSelectedLayoutSegments,
} from 'next/navigation';

export function ClientConfig() {
    const pathname = usePathname();
    const params = useParams();
    const searchParams = useSearchParams();
    const segments = useSelectedLayoutSegments();

    return (
        <pre className="p-xs overflow-auto bg-gray-50 text-sm">
            {JSON.stringify(
                {
                    pathname,
                    params,
                    searchParams,
                    segments,
                },
                null,
                2
            )}
        </pre>
    );
}
